import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import Dropdown from "components/Input/Dropdown"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, MdrOffUs, MdrOnUs, MdrQrisOffUs, MdrQrisOnUs, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { ApiDeleteEdc, ApiGetBankList, ApiGetBeneficiaryAccountList, ApiGetEdc, ApiGetEdcList, ApiGetTransaction, ApiGetTransactionCustomerCard, ApiInsertEdc, ApiUpdateEdc, ApiUpdateTransaction } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { decimal, GetStatus, money } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import DatePicker from "components/Input/DatePicker"

export default function TransactionReportForm(){
    const navigate = useNavigate()

    const { fetch: getBankList } = useFetch(ApiGetBankList)
    const { fetch: insertEdc } = useFetch(ApiInsertEdc)
    const { fetch: updateEdc } = useFetch(ApiUpdateEdc)
    const { fetch: updateTransaction } = useFetch(ApiUpdateTransaction)
    const { fetch: deleteEdc } = useFetch(ApiDeleteEdc)
    const { fetch: getEdc } = useFetch(ApiGetEdc)
    const { fetch: getTransaction } = useFetch(ApiGetTransaction)
    const { fetch: getBeneficiaryList } = useFetch(ApiGetBeneficiaryAccountList)
    const { fetch: getCustomerCardList } = useFetch(ApiGetTransactionCustomerCard)
    const { fetch: getEdcList } = useFetch(ApiGetEdcList)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramEdcId = queryString.get("edcId")
    let trxId = queryString.get("trxId")

    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [edcName, setEdcName] = useState(EmptyString)
    const [mdrOn, setMdrOn] = useState(EmptyString)
    const [mdrOff, setMdrOff] = useState(EmptyString)
    const [mdrQrisOn, setMdrQrisOn] = useState(EmptyString)
    const [mdrQrisOff, setMdrQrisOff] = useState(EmptyString)
    const [beneficiaryOptions, setBeneficiaryOptions] = useState([])
    const [beneficiaryId, setBeneficiaryId] = useState(EmptyString)

    const [customerName, setCustomerName] = useState(EmptyString)

    const [amount, setAmount] = useState(EmptyString)
    const [trMdr, setTrMdr] = useState(EmptyString)
    const [netto, setNetto] = useState(EmptyString)
    const [transactionType, setTransactionType] = useState(MdrOnUs);
    const [mdrEdcOnUs, setMdrEdcOnUs] = useState(EmptyString)
    const [mdrEdcOffUs, setMdrEdcOffUs] = useState(EmptyString)
    const [mdrQrisOnUs, setMdrQrisOnUs] = useState(EmptyString)
    const [mdrQrisOffUs, setMdrQrisOffUs] = useState(EmptyString)
    const [transactionDate, setTransactionDate] = useState(null)
    const [customerCard, setCustomerCard] = useState(EmptyString)
    const [customerCardOptions, setCustomerCardOptions] = useState([])
    const [edcData, setEdcData] = useState([])
    const [edc, setEdc] = useState(EmptyString)
    const [edcOptions, setEdcOptions] = useState([])
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [errorBankId, setErrorBankId] = useState(false)
    const [errorEdcName, setErrorEdcName] = useState(false)
    const [errorBeneficiaryAccountNo, setErrorBeneficiaryAccountNo] = useState(false)
    const [errorMdrOn, setErrorMdrOn] = useState(false)
    const [errorMdrOff, setErrorMdrOff] = useState(false)
    
    const customerCardOnInput = (e) => {
        fGetCustomerCardList(e)
    }
    const customerCardChange = (e) => {
        setCustomerCard(e)
        // setLoading({isOpen: true})
        // setCustomerCard(e)
        // fGetCustomerCard(e.value).then(() => {
        //     setLoading({isOpen: false})
        // })
    }
    const transactionDateChange = (e) => {
        if (e === null) {
            setTransactionDate(new Date())
        }else{
            setTransactionDate(e)
        }
    }
    const edcChange = (e) => {
        setEdc(e)
        
        if (edcData.length > 0){
            for(let i=0; i < edcData.length; i++){
                if(edcData[i].edcId == e.value){
                    setMdrEdcOffUs(edcData[i].mdrOff)
                    setMdrEdcOnUs(edcData[i].mdrOn)
                    setMdrQrisOnUs(edcData[i].mdrQrisOn)
                    setMdrQrisOffUs(edcData[i].mdrQrisOff)
                }
            }
        }
    }
    const handleChange = (event) => {
        setTransactionType(event.target.value);
    }
    const amountChange = (e) => {
            fCalculateNetto(e.target.value, trMdr)
            setAmount(money(e.target.value))        
    }
    const trMdrChange = (e) => {
        let inputValue = e.target.value

        if (inputValue !== EmptyString){
            let number = parseInt(inputValue)
            if (number > 100){
                
            }else{
                setTrMdr(decimal(e.target.value))
            }
        }else{
            setTrMdr(decimal(e.target.value))
        }
        
        
    }
    const trMdrKeyUp = (e) => {
        fCalculateNetto(amount, e.target.value)
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })


    useEffect(() => {
        setLoading({ isOpen: true })

        fGetCustomerCardList(EmptyString).then(() => {
            fGetEdcList(EmptyString).then(() => {
                fGetTransaction().then(() => {
                    setLoading({ isOpen: false })
                })
            })
        })
        
    }, [])

    // Function Api Call
    async function fGetTransaction(){
        await getTransaction({
            data: {
                transactionId: trxId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setMdrEdcOnUs(data.mdrEdcOnUs)
                setMdrEdcOffUs(data.mdrEdcOffUs)
                setMdrQrisOnUs(data.mdrQrisOnUs)
                setMdrQrisOffUs(data.mdrQrisOffUs)
                setCustomerCard({ label: data.customerCardNumber + ' - ' + data.customerName, value: String(data.customerCardId) })
                setTransactionDate(data.transactionDate)
                setEdc({label: data.bankCode + ' - ' + data.edcName, value: String(data.edcId)})
                setAmount(money(data.amount))
                if (data.type === "1"){
                    setTransactionType(MdrOnUs)
                } else if (data.type === "2"){
                    setTransactionType(MdrOffUs)
                } else if (data.type === "3"){
                    setTransactionType(MdrQrisOnUs)
                } else if (data.type === "4"){
                    setTransactionType(MdrQrisOffUs)
                }
                setTrMdr(data.mdr)
                setNetto(money(data.netto))
                setStatus(data.status)
                setCreateDate(moment(data.createDate).format('DD MMM yyyy'))
                setUpdateDate(moment(data.updateDate).format('DD MMM yyyy'))
                setUpdateBy(data.updateBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetEdcList(searchParam){
        await getEdcList({
            data: {
                bankId: EmptyString,
                edcName: searchParam, 
                beneficiaryAccountNo: EmptyString,
                beneficiaryName: EmptyString,
                status: StatusCodeActive,
                pageSize: 500,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    setEdcData(data)
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].bankCode + " - " + data[i].edcName.toUpperCase(), value: String(data[i].edcId) })
                    }

                    setEdcOptions(tempArray)
                    setEdc(tempArray[0].value)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fInsertEdc(){
        await insertEdc({
            data:{
                bankId: bankId,
                edcName: edcName,
                beneficiaryAccountNo: "0",
                mdrOn: mdrOn,
                mdrOff: mdrOff,
                mdrQrisOn: mdrQrisOn,
                mdrQrisOff: mdrQrisOff,
                beneficiaryId: beneficiaryId.value
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/setting/edc") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateEdc(){
        await updateEdc({
            data:{
                edcId: paramEdcId,
                bankId: bankId,
                edcName: edcName,
                beneficiaryAccountNo: "0",
                mdrOn: mdrOn,
                mdrOff: mdrOff,
                mdrQrisOn: mdrQrisOn,
                mdrQrisOff: mdrQrisOff,
                beneficiaryId: beneficiaryId.value
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/setting/edc") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateTransaction(){
        let trxType = ''

        if (transactionType === MdrOnUs){
            trxType = "1"
        } else if (transactionType === MdrOffUs){
            trxType = "2"
        } else if (transactionType === MdrQrisOnUs){
            trxType = "3"
        } else if (transactionType === MdrQrisOffUs){
            trxType = "4"
        } else {
            trxType = ""
        }

        await updateTransaction({
            data:{
                transactionId: trxId, 
                customerCardId: customerCard.value,
                transactionDate: moment(transactionDate).format('yyyy-MM-DD'),
                edcId: edc.value,
                mdrEdcOffUs: mdrEdcOffUs, 
                mdrEdcOnUs: mdrEdcOnUs, 
                mdrQrisOnUs: mdrQrisOnUs, 
                mdrQrisOffUs: mdrQrisOffUs, 
                type: trxType, 
                amount: amount.replaceAll(',', ''), 
                mdr: trMdr, 
                netto: netto.replaceAll(',', '')
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/transaction-report") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fDeleteEdc(){
        await deleteEdc({
            data:{
                edcId: paramEdcId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/setting/edc") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetCustomerCardList(searchParam){
        await getCustomerCardList({
            data: {
                customerName: searchParam,
                cardNumber: EmptyString,
                bankId: 0,
                cardVendorId: 0,
                status: StatusCodeActive,
                pageSize: 50,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].cardNumber + " - " + data[i].customerName, value: String(data[i].customerCardId) })
                    }

                    setCustomerCardOptions(tempArray)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    const saveBtnClick = () => {
        if (validateForm()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if (formType === FormTypeAdd){
                    
                } else if (formType === FormTypeEdit){
                    fUpdateTransaction().then(() => {
                        setLoading({isOpen: false})
                    })
                } else {
                    setLoading({ isOpen: false })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fDeleteEdc().then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        // if (bankId === EmptyString){
        //     setErrorBankId(true)
        //     errorCount++
        // }else{
        //     setErrorBankId(false)
        // }

        // if (edcName === EmptyString){
        //     setErrorEdcName(true)
        //     errorCount++
        // }else{
        //     setErrorEdcName(false)
        // }

        // if (beneficiaryAccountNo === EmptyString){
        //     setErrorBeneficiaryAccountNo(true)
        //     errorCount++
        // }else{
        //     setErrorBeneficiaryAccountNo(false)
        // }

        // if (mdrOn === EmptyString){
        //     setErrorMdrOn(true)
        //     errorCount++
        // }else{
        //     setErrorMdrOn(false)
        // }

        // if (mdrOff === EmptyString){
        //     setErrorMdrOff(true)
        //     errorCount++
        // }else{
        //     setErrorMdrOff(false)
        // }

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fCalculateNetto(amount, mdrInput){
        let xAmount = amount === EmptyString ? 0 : parseFloat(amount.replaceAll(",", ""))
        let xMdr = mdrInput === EmptyString ? 0 : parseFloat(mdrInput)
        let xNetto = xAmount - (xAmount * xMdr / 100)
        setNetto(money(parseInt(xNetto)))
    }

    return (
        <div className="flex flex-col gap-2">
            <div>
                <div className="flex justify-between">
                    <span className="font-semibold text-2xl">Transaction Detail</span>
                    <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                        <span className="text-sm opacity-60">
                            Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                        </span>
                    </div>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Customer */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Customer Name</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-[560px]">
                                <Select options={customerCardOptions} value={customerCard} onInputChange={customerCardOnInput} onChange={customerCardChange} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Transaction Date */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Transaction Date</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <DatePicker className="w-full h-10 bg-white" value={transactionDate} onChange={transactionDateChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorEdcName ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Edc Name is required!</span>
                    </div>
                </div>

                {/* Mesin EDC */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>EDC</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72 md:w-72">
                                <Select options={edcOptions} value={edc} onChange={edcChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorBeneficiaryAccountNo ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Beneficiary Account No is required!</span>
                    </div>
                </div>

                {/* Tipe */}
                <div className="py-2">
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Type</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="flex gap-2 w-full sm:w-[560px]">
                                {/* <div className="flex gap-4 justify-start items-start"> */}
                                    <label className="flex gap-2">
                                        <input type="radio" value={MdrOnUs} checked={transactionType === MdrOnUs} onChange={handleChange} />
                                        On Us
                                    </label>
                                    <label className="flex gap-2">
                                        <input type="radio" value={MdrOffUs} checked={transactionType === MdrOffUs} onChange={handleChange} />
                                        Off Us
                                    </label>
                                {/* </div> */}
                                {/* <div className="flex gap-4"> */}
                                    <label className="flex gap-2">
                                        <input type="radio" value={MdrQrisOnUs} checked={transactionType === MdrQrisOnUs} onChange={handleChange} />
                                        Qris On Us
                                    </label>

                                    <label className="flex gap-2">
                                        <input type="radio" value={MdrQrisOffUs} checked={transactionType === MdrQrisOffUs} onChange={handleChange} />
                                        Qris Off Us
                                    </label>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorMdrOn ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Mdr On Us is required!</span>
                    </div>
                </div>

                {/* Amount */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Amount (Jumlah Gesek)</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={amount} onChange={amountChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorMdrOff ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Mdr Off Us is required!</span>
                    </div>
                </div>

                {/* Mdr */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Mdr</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={trMdr} onChange={trMdrChange} onKeyUp={trMdrKeyUp} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorMdrOff ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Mdr Off Us is required!</span>
                    </div>
                </div>

                {/* Received Amount */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Received Amount</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={netto} disabled={true} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorMdrOff ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Mdr Off Us is required!</span>
                    </div>
                </div>
            </div>
                

            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick}  />
            </div>

             {/* Modal */}
 			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
 			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}